import { TRootState } from '../reducers';
import { IFieldState } from '../reducers/types';

export const selectFieldState = (state: TRootState): IFieldState => state.field;

export const selectFieldNodeId = (state: TRootState): string | undefined => {
  return state.field.nodeId;
};

export const selectIsChange = (state: TRootState): boolean | undefined => {
  return state.field.change;
};
